export default "__VITE_ASSET__BWRt$D4T__"